export const tableFieldCarSearchHistory = [
  { value: 'image', text: 'langkey.image', align: 'center' },
  { value: 'description', text: 'langkey.car-history-description', align: 'center' },
  { value: 'version', text: 'langkey.breadcrumb-version', align: 'center' },
  { value: 'searchTime', text: 'langkey.car-history-search-time', align: 'center' },
];